<template>
  <section class="section first_page">
    <div class="container-flud ">
      <loading-block v-if="is_load==false" :loading="!is_load"/>
      <div class="col-md-12 center-block  d-flex justify-content-center loading_div " v-if="is_load==false">
        <h2>Идет загрузка...</h2>
      </div>
      <div   v-if="is_load">
        <common-user-page :user="user" />

        <div class="col-12 text-center mt-2" v-if="invoices.length==0">
          <p>Не найдено подтверждений что вы работали с этим пользователем</p>
        </div>
        <div class="container mt-3">
        <div class="col-12 mt-2 " v-if="invoices.length>0" ref="orderform">
          <h2 class="text-center">Написать отзыв</h2>
          <div class="form-group row">
            <div class="col-md-3 col-12">
              <p class="mt-2">Счет</p>
            </div>
            <div class="col-md-9 col-12">
              <select class="form-control mt-2 mb-md-5" v-model="new_review.invoice_id">
                <option  v-for="invoice in invoices" :value="invoice.last_id"
                    :key="invoice.last_id">Счет {{
                    invoice.last_id
                  }}
                </option>
              </select>
            </div>



          </div>

          <div class="form-group row">
            <div class="col-md-3 col-12">
              <p class="mt-2">Оценка</p>
            </div>
            <div class="col-md-9 col-12">
              <select class="form-control mt-2 mb-md-5" v-model="new_review.rating">
                <option value="5">5</option>
                <option value="4">4</option>
                <option value="3">3</option>
                <option value="2">2</option>
                <option value="1">1</option>
              </select>
            </div>



          </div>



          <editorjsinput   ref="editorjs" :blocks_json="new_review.review" ></editorjsinput>






          <div class="d-flex justify-content-center mx-auto">
            <div class="alert alert-danger" v-if="iserror==true">
              <p>{{ error_message }}</p>
            </div>
          </div>

          <div class="d-flex justify-content-center mx-auto">
            <base-button  @click="onSave"  >Добавить отзыв</base-button>
          </div>
        </div>
        </div>






      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Vue from "vue";
import CommonUserPage from "@/components/user_page/CommonUserPage";
import Editorjsinput from "@/models/Editorjsinput";
import VLazyImage from "v-lazy-image/v2";

export default {
  name: "UserPageAddReview",
  data(){
    return {
      "is_load":false,
      'user':null,
      'invoices':null,
      'new_review':{
        'invoice_id':null,
        'rating':5,
        'review':[
          {
            "type": "header",
            "data": {
              "text": "Мой отзыв",
              "level": 2
            }
          },

          {
            "type": "paragraph",
            "data": {
              "text": "Здесь я чем то доволен или нет",
            }
          },

        ],
      },
      'image_url':null,
      'iserror':false,
      'error_message':'',
    };
  },
  components: {Editorjsinput,LoadingBlock,CommonUserPage,VLazyImage},
  mounted: function () {
    var app=this;
    var id=this.$route.params.user_id;
    app.is_load=false;
    app.image_url = Vue.config.IMAGE_URL;
    app.loadMainData(id);
  },
  methods:{
    loadMainData(id){
      var app=this;
      Api.loadUserPageAddReview(id,function(data){
        app.user=data.user;
        app.invoices=data.invoices;
        if(app.invoices[0] && app.invoices[0].last_id){
        app.new_review.invoice_id=app.invoices[0].last_id;
        }
        app.is_load=true;
      },function(error){

        if(error.response.data.code==404){
          app.$router.push({name:'404'});
        }
      });

    },
    onSave(){
      var app=this;
      app.is_load=false;
      app.$refs.editorjs.save(function(editor_js_data){
        app.new_review.review=editor_js_data.blocks;
        var new_review={};
        new_review.rating=app.new_review.rating;
        new_review.invoice_id=app.new_review.invoice_id;

        new_review.review=editor_js_data;


        Api.addReview(app.user.last_id,new_review, function (result) {
          app.is_load=true;

          app.iserror = false;

            //document.location = "/project/" + result.project_id;
            app.$router.push({name: 'user_page_reviews', params: {user_id: app.user.last_id}});

        },function(err_message){
          app.is_load=true;
          app.iserror=true;

          app.error_message = err_message;
        });




      });
    },
  }
}
</script>

<style scoped>

</style>